// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__3YUZT","avatar":"style_avatar__6We30"};